import React, { useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { StyledEngineProvider } from '@mui/material/styles';

import "./styles.css";

/**
 * @name AccordionView
 * @function
 * @param {STRING} className - Additional classes to add to the accordion view
 * @param {React.Component} children - Add child accordion components or elements to the main component.
 * @extends React.Component
 * @exported true
 * @description The main component for a accordion view
 * @link [Accordion API](https://mui.com/material-ui/api/accordion/)
 * @example
 * <AccordionView>
 *   <AccordionHeader>
 *      Header
 *   </AccordionHeader>
 *   <AccordionContent>
 *      Content goes here
 *   </AccordionContent>
 * </AccordionView>   
 */
export default function AccordionView(props) {
    const { className, ...other } = props;

    return (
        <StyledEngineProvider injectFirst>
            <Accordion className={`accordion-view ${className}`} {...other} elevation={0} disableGutters>
                {props.children}
            </Accordion>
        </StyledEngineProvider>
    )
}

/**
 * @name AccordionHeader
 * @function
 * @param {STRING} className - Additional classes to add to the accordion view
 * @param {React.Component} children - Insert child components/elements to the accordion header.
 * @extends React.Component
 * @exported true
 * @description The main component for a accordion header
 * @link [AccordionSummary API](https://mui.com/material-ui/api/accordion-summary/)
 * @example
 * <AccordionView>
 *   <AccordionHeader>
 *      Header
 *   </AccordionHeader>
 *   <AccordionContent>
 *      Content goes here
 *   </AccordionContent>
 * </AccordionView>   
 */
export function AccordionHeader(props) {
    const { className, ...other } = props;

    return (
        <AccordionSummary className={`accordion-header ${className}`} {...other} >
            {props.children}
        </AccordionSummary>
    )
}

/**
 * @name AccordionContent
 * @function
 * @param {STRING} className - Additional classes to add to the accordion view
 * @param {React.Component} children - Insert child components/elements to the accordion content.
 * @extends React.Component
 * @exported true
 * @description The main component for a accordion content 
 * @link [AccordionDetails API](https://mui.com/material-ui/api/accordion-details/)
 * @example
 * <AccordionView>
 *   <AccordionHeader>
 *      Header
 *   </AccordionHeader>
 *   <AccordionContent>
 *      Content goes here
 *   </AccordionContent>
 * </AccordionView>   
 */
export function AccordionContent(props) {
    const { className, ...other } = props;

    return (
        <AccordionDetails className={`accordion-content ${className}`} {...other}>
            {props.children}
        </AccordionDetails>
    )
}